import { useEffect, useState } from 'react';
import eventBus from "../services/eventBus";

export default function TagItem(props) {
    
    const [state, setState] = useState({selected: false});

    useEffect(() => {
        setState({selected: props.selected});
        eventBus.subscribe('disableTag', disableTag);
        eventBus.subscribe('enableTag', enableTag);
    }, [])

    const updateTag = async () => {
        // eventBus.emit('updateTags', {tag: props.text});
        if(props.modal) { //do not highligh tags in modal popup
            props.hideModel();
            props.updateTags({tag: props.text});
            eventBus.emit('enableTag', {tag: props.text});
            eventBus.emit('disableTag', {tag: "All"});
            document.querySelector('.tags').scrollLeft = document.querySelector('.tag[data-tag="' + props.text + '"]').offsetLeft - 100;
        }else {
            if(props.text != "All") {
                props.updateTags({tag: props.text});
                
                setState((o) => {return {selected: !state.selected}});

                // if(!state.selected) {
                //     eventBus.emit('disableTag', {tag: "All"});
                // }
            }else if(props.text == "All" && !state.selected) {
                props.updateTags({tag: props.text});

                setState({selected: !state.selected});
            }
        }
    }

    const disableTag = (tag) => {
        if(tag.tag === props.text) {
            setState({selected: false});
        }
    }

    const enableTag = (tag) => {
        if(tag.tag === props.text) {
            setState({selected: true});
        }
    }
 
    return(
        <span data-tag={props.text} className={`tag ${state.selected ? "tag-selected" : ''}`} onClick={updateTag}>{props.text}</span>
    );
}